import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

type Props = {
  width?: number;
  height?: number;
};

const LoginIcon = ({ width = 27, height = 26 }: Props): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M24 3.3186H17.25V1.7561C17.25 0.891846 16.5797 0.193604 15.75 0.193604H11.25C10.4203 
      0.193604 9.75 0.891846 9.75 1.7561V3.3186H3C1.34531 3.3186 0 4.71997 0 6.4436V22.0686C0 
      23.7922 1.34531 25.1936 3 25.1936H24C25.6547 25.1936 27 23.7922 27 22.0686V6.4436C27 4.71997 
      25.6547 3.3186 24 3.3186ZM12 2.53735H15V5.66235H12V2.53735ZM24.75 22.0686C24.75 22.4983 24.4125 
      22.8499 24 22.8499H18.7125C18.7219 22.7961 18.75 22.7473 18.75 22.6936V21.7561C18.75 20.2034 17.3391 
      18.9436 15.6 18.9436C15.0937 18.9436 14.7234 19.3342 13.5 19.3342C12.2391 19.3342 11.9344 18.9436 
      11.4 18.9436C9.66094 18.9436 8.25 20.2034 8.25 21.7561V22.6936C8.25 22.7473 8.27344 22.7961 8.2875 
      22.8499H3C2.5875 22.8499 2.25 22.4983 2.25 22.0686V6.4436C2.25 6.01392 2.5875 5.66235 3 
      5.66235H9.75V8.0061H17.25V5.66235H24C24.4125 5.66235 24.75 6.01392 24.75 6.4436V22.0686ZM13.5 
      11.1311C11.8453 11.1311 10.5 12.5325 10.5 14.2561C10.5 15.9797 11.8453 17.3811 13.5 17.3811C15.1547 
      17.3811 16.5 15.9797 16.5 14.2561C16.5 12.5325 15.1547 11.1311 13.5 11.1311Z"
      fill={colors.bright_turquoise}
    />
  </VectorIcon>
);

export default LoginIcon;
